module.exports = __webpack_public_path__ + "media/images/athletes/3580-1d47f0b1650a6e6b0a17f4c37e2cfc79.png";